import { Routes, Route, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import LoginPage from './pages/login/LoginPage';
import PrivateRoute from './components/auth/PrivateRoute';
import { useEffect } from 'react';
import WorkshopsPage from './pages/workshops/WorkshopsPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import InvoicesPage from './pages/invoices/InvoicesPage';
import BibliothequePages from './pages/bibliotheque/BibliothequePages';

function App() {
  const location = useLocation();

  

  useEffect(() => {
    if (location.pathname === '/login') {
      document.title = "L'Autre Part - Se connecter";
    } else if (location.pathname === '/dashboard') {
      document.title = "L'Autre Part - Dashboard";
    } else if (location.pathname === '/workshops') {
      document.title = "L'Autre Part - Ateliers";
    } else if (location.pathname === '/bibliotheque') {
      document.title = "L'Autre Part - Bibliothèque";
    } else {
      document.title = "L'Autre Part - Dashboard";
    }
  }, [location.pathname]);

  return (
    <Routes>
      {/* Page publique : Login */}
      <Route path="/login" element={<LoginPage />} />

      {/* Routes privées protégées */}
      <Route
        path="*"
        element={
          <PrivateRoute>
            <div className="h-screen flex">
              <Sidebar />
              <main className="flex-1 overflow-hidden flex flex-col">
                <Header />
                <div className="flex-1 overflow-auto p-4 bg-gray-50">
                  <Routes>
                    <Route path="/" element={<DashboardPage />} />
                    <Route path="/workshops" element={<WorkshopsPage />} />
                    <Route path="/invoices" element={<InvoicesPage />} />
                    <Route path="/bibliotheque" element={<BibliothequePages />} />
                  </Routes>
                </div>
              </main>
            </div>
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

export default App;
